import { render, staticRenderFns } from "./detallesMantenimientosAutorizaciones.vue?vue&type=template&id=016b8cbb&scoped=true"
import script from "./detallesMantenimientosAutorizaciones.vue?vue&type=script&lang=js"
export * from "./detallesMantenimientosAutorizaciones.vue?vue&type=script&lang=js"
import style0 from "./detallesMantenimientosAutorizaciones.vue?vue&type=style&index=0&id=016b8cbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016b8cbb",
  null
  
)

export default component.exports